<template>
    <div class="keyword-input-container">
        <p class="title">
            <slot></slot>
        </p>
        <div class="input-wrapper">
            <input
                v-model="$v.keywordInput.$model"
                @keyup.enter="handleAddTag($v.keywordInput.$dirty && !$v.keywordInput.tag)"
                @keydown="$v.keywordInput.$touch"
                @blur="$v.keywordInput.$touch"
                @focus="$v.keywordInput.$reset"
                class="keyword-input"
                :style="
                    $v.keywordInput.$dirty && !$v.keywordInput.tag
                        ? { 'border-color': '#ed3c0d' }
                        : {}
                "
                type="text"
                :placeholder="placeholder"
            />
            <button
                @click="handleAddTag($v.keywordInput.$dirty && !$v.keywordInput.tag)"
                class="add-vibe-btn"
            >
                Add
            </button>
        </div>
        <div v-if="keywords.length" class="keywords">
            <div v-for="(tag, indx) in keywords" :key="indx" class="tag-wrapper">
                <span @click="handleDeleteTag(indx)" class="tag">{{ tag }}</span>
            </div>
        </div>
    </div>
</template>
<script>
    import useKeywords from '@/composables/useKeywords.js'
    import { useAuth } from '@/composables/auth/useAuth'

    export default {
        name: 'KeywordInput',
        props: {
            placeholder: {
                type: String,
                required: false,
                default: 'Type to add a tag'
            }
        },
        setup() {
            const { userValues } = useAuth()
            const { keywordInput, keywords, handleAddTag, handleDeleteTag } = useKeywords(
                [],
                userValues.value.keywords ? userValues.value.keywords.split(',') : []
            )

            return {
                userValues,
                keywordInput,
                keywords,
                handleAddTag,
                handleDeleteTag
            }
        },
        validations: {
            keywordInput: {
                tag: (v) => !!(!v || /^[ &a-zA-Z0-9-_,;]+$/.test(v))
            }
        }
    }
</script>
<style lang="scss" scoped>
    .keyword-input-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 6px;

        p {
            margin-bottom: 0px;
        }
        button {
            border: none;
        }
        .title {
            color: #8b8b8b;
            font-family: Instrument Sans;
            font-size: 12px;
            font-style: normal;
            font-weight: 650;
            line-height: 135%;
            letter-spacing: 0.12px;
            align-self: flex-start;
        }
        .input-wrapper {
            display: flex;
            justify-content: space-between;
            width: 100%;
            gap: 8px;

            .keyword-input {
                padding: 12px 16px 16px 16px;
                border-radius: 12px;
                border: 1px solid #8b8b8b;
                background: #262626;
                overflow: hidden;
                color: #dedede;
                text-overflow: ellipsis;
                white-space: nowrap;
                font-family: Instrument Sans;
                font-size: 16px;
                font-style: normal;
                font-weight: 550;
                line-height: 125%;
                align-self: stretch;
                width: 100%;
            }
            .add-vibe-btn {
                max-width: 123px;
                padding: 11px 30px 12px 30px;
                border-radius: 100px;
                background: #cdeb09;
                color: black;
                font-family: Instrument Sans;
                font-size: 18px;
                font-style: normal;
                font-weight: 550;
                line-height: 120%;
            }
        }
        .keywords {
            margin-top: 24px;
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            max-width: 1044px;
            width: 100%;
            min-height: 36px;
            height: 100%;
            gap: 8px;
            .tag-wrapper {
                min-height: 40px;

                span {
                    cursor: pointer;
                    padding: 7px 28px 9px 30px;
                    border-radius: 100px;
                    border: 1px solid #cdeb09;
                    background: #262626 url('/images/icons/delete-yellow.svg') no-repeat 92%
                        50%;
                    background-size: 8px 8px;
                    color: #cdeb09;
                    font-family: Instrument Sans;
                    font-size: 16px;
                    font-style: normal;
                    font-weight: 650;
                    line-height: 125%;
                }
            }
        }
    }
</style>
